import {Inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";

@Injectable({providedIn: "root"})
export class RefreshtokenService {

  constructor(private http: HttpClient) {
  }

  refreshToken(): Observable<any> {
    const url = `${environment.apiTokenUrl}/oauth/wso2/refresh`;
    return this.http.get(url);
  }
}
